import React from 'react';

const AboutMe = () => {
  return (
    <section id="about">
      <h2>O mnie</h2>
      <div className="about-content">
        <p>
          Cześć! Mam na imię Marcel i jestem programistą. Zajmuję się tworzeniem aplikacji webowych, zarówno front-endowych, jak i back-endowych, oraz automatyzacją testów. Cały czas rozwijam swoje umiejętności w szerokim zakresie technologii i narzędzi, takich jak React, JavaScript, Python, oraz wiele innych.
        </p>
        <p>
          Poza programowaniem, mam wiele innych pasji. Regularnie trenuję na siłowni, dbam o swoją kondycję fizyczną i staram się balansować życie zawodowe z aktywnością fizyczną. W wolnym czasie uwielbiam łowić ryby – to dla mnie sposób na relaks i oderwanie się od codziennych obowiązków.
        </p>
        <p>
          Moim celem jest ciągły rozwój i zdobywanie nowych umiejętności, zarówno w programowaniu, jak i w innych dziedzinach życia. Dążę do tego, aby być na bieżąco z najnowszymi technologiami i zawsze szukać sposobów na optymalizację moich procesów pracy. W przyszłości chciałbym pogłębić swoją wiedzę z zakresu sztucznej inteligencji oraz rozwiązań chmurowych.
        </p>
        <p>
          Jeśli chcesz dowiedzieć się więcej o mojej pracy lub porozmawiać o technologiach, zapraszam do kontaktu!
        </p>
      </div>
    </section>
  );
};

export default AboutMe;
